module.exports = __webpack_public_path__ + "static/media/assessment-no-data-img.e2ef61af.svg";